module.exports = __webpack_public_path__ + "static/media/20.2b9a6c6d.JPG";